import { Language } from '@axo/config/@types/Language.types';
import { ProgressIndicatorLabels } from './ProgressIndicator.types';

export const labels = <Record<Language, ProgressIndicatorLabels>>{
  en: {
    next: 'Next',
    complete: 'Complete',
  },
  da: {
    next: 'Næste',
    complete: 'Udfyldt',
  },
  fi: {
    next: 'Seuraava',
    complete: 'Täydellinen',
  },
  sv: {
    next: 'Nästa',
    complete: 'Komplett',
  },
  nb: {
    next: 'Neste',
    complete: 'Fullført',
  },
};
